import React from 'react'
import utils from "../../modules/utils";

class CTA extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const gState = utils.getState();
        let text = "";
        if (gState.prodotto !== 3) {
            text = "Per il tuo prestito, basta un giorno.";
        }
        if (gState.prodotto===4) { //Carte di credito
            text = "Fido a partire da 1.500 euro.";
        }
        return (
            <h4 className="gsap-fade">{text}</h4>
        )
    }
}

export default CTA


// WEBPACK FOOTER //
// ./src/components/shared/cta.js